// extracted by mini-css-extract-plugin
module.exports = {"useFade-fadeIn":"OrderSummary_useFade-fadeIn__gg3Ac","useFade-fadeOut":"OrderSummary_useFade-fadeOut__iDVT_"};